// extracted by mini-css-extract-plugin
module.exports = {"assets-section":"assets-section___2n7Bw","media-attention":"media-attention___2TGMT"};